module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0245.47734ac0.jpg";